import { AggregateJob } from "../../../server/repositories/aggregate-job/model";

export const initAggregateJob = (jobId: string): Partial<AggregateJob> => {
	return {
		import_type: "completed",
		job_id: jobId,
	};
};
